import Head from "next/head";
import BreadcrumbScrollCX from "../../../components/Elements/BreadcrumbScrollCX/BreadcrumbScrollCX";
import cx from "classnames";
import styles from "../../../styles/CXpages.module.css";
import ogCX from "../../../images/ogCX.png";
import { useRef, useState } from "react";
import { useScroll, motion, calcLength } from "framer-motion";
import { useDetectScroll } from "@smakss/react-scroll-direction";
import cxVline from "../../../images/cxVline.svg";
import useIntersection from "../../../components/Services/useIntersection";
import Image from "next/image";
import circle from "../../../images/circle.svg";
import linkShare from "../../../images/linkShare.svg";
import emailShare from "../../../images/emailShare.svg";
import telegramShare from "../../../images/telegramShare.svg";
import whatsappShare from "../../../images/whatsappShare.svg";
import iPhoneFrame from "../../../images/iPhoneFrame.svg";

import { useRouter } from "next/router";
import Snackbar from "@mui/material/Snackbar";
import like from "../../../images/like.svg";
import dislike from "../../../images/dislike.svg";
import sentimentChartDesktop from "../../../images/sentimentChartDesktop.svg";
import sentimentChartMobile from "../../../images/sentimentChartMobile.svg";
import Link from "next/link";
import cx1 from "../../../images/cx1.svg";
import cx2 from "../../../images/cx2.svg";
import cx3 from "../../../images/cx3.svg";
import cx4 from "../../../images/cx3.svg";

import cxr1 from "../../../images/cxr1.svg";
import cxr2 from "../../../images/cxr2.svg";
import cxr3 from "../../../images/cxr3.svg";
import cxr4 from "../../../images/cxr4.svg";
import cxr5 from "../../../images/cxr5.svg";
import cxr6 from "../../../images/cxr6.svg";

import cxArrow from "../../../images/cxArrow.svg";

const Index = () => {
  const router = useRouter();

  const pageDetails = {
    pageTitle: "حقوق مشتریان",
    pagePath: `https://about.digikala.com${router.asPath}`,
    pageDesc:
      "دیجی‌کالا دو نوع تعهد نسبت به مشتریان خود دارد؛ تعهداتی که در راستای مشتری‌مداری و ایجاد تجربه خوب توسط برند تعریف و به مشتری وعده داده شده، و تعهداتی که به موجب قانون تکلیف شده و دارای ضمانت اجرایی حقوقی است.",
  };

  // toast handler after link copy
  const [openToast, setOpenToast] = useState(false);
  const onShareHandler = () => {
    navigator.clipboard.writeText(pageDetails.pagePath);
    openToastHandler();
  };
  const openToastHandler = () => {
    setOpenToast(true);
  };
  const closeToastHandler = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToast(false);
  };
  // end of toast handler after link copy

  const ref1 = useRef();
  const ref2 = useRef();

  const refBillion = useRef();

  const { scrollYProgress: scroll1 } = useScroll({
    target: ref1,
    offset: ["start end", "end end"],
  });
  const { scrollYProgress: scroll2 } = useScroll({
    target: ref2,
    offset: ["start end", "end end"],
  });

  const { scrollYProgress: scrollAll } = useScroll({
    offset: ["start end", "end end"],
  });
  const spring = {
    type: "spring",
    damping: 10,
    stiffness: 1,
  };

  const [scrollDir] = useDetectScroll({});

  const ref1inViewport = useIntersection(ref1, "0px");
  const ref2inViewport = useIntersection(ref2, "0px");

  return (
    <>
      <Head>
        <title>{pageDetails.pageTitle}</title>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <meta charSet="utf-8" />
        <meta name="description" content={pageDetails.pageDesc} />
        <link rel="icon" type="image/x-icon" href="/faviconNew.svg"></link>
        <meta
          name="robots"
          content="index, follow, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
        />
        <meta property="og:locale" content="fa_IR" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={pageDetails.pageTitle} />
        <meta property="og:url" content={pageDetails.pagePath} />
        <meta property="og:site_name" content="درباره گروه دیجی‌کالا" />
        <meta property="og:image" itemProp="image" content="/ogCX.png" />
        <meta property="og:image:width" content="665" />
        <meta property="og:image:height" content="370" />
        <meta property="og:image:alt" content={pageDetails.pageTitle} />
        <meta property="og:image:type" content="image/png" />
        <meta
          property="og:site_name"
          content="درباره گروه دیجی‌کالا"
          key="ogsitename"
        />
        <meta
          property="og:title"
          content={pageDetails.pageTitle}
          key="ogtitle"
        />
        <meta
          property="og:description"
          content={pageDetails.pageDesc}
          key="ogdesc"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageDetails.pageTitle} />
        <meta name="twitter:site" content="درباره گروه دیجی‌کالا" />
        <meta
          name="twitter:image"
          content="https://about.digikala.com/ogCX.png"
        />
        <meta name="twitter:description" content={pageDetails.pageDesc} />
      </Head>

      <Snackbar
        open={openToast}
        autoHideDuration={2000}
        onClose={closeToastHandler}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        message={
          <div className="w-100 d-flex align-items-center justify-content-between">
            <span className={cx(styles.toasTextStyles, "d-flex", "w-100")}>
              لینک مطلب کپی شد!
            </span>
          </div>
        }
      />

      <BreadcrumbScrollCX
        title="حقوق مشتریان"
        routeOne="/customer-experience/"
        titleOne="درباره تجربه مشتریان"
        routeTwo="/customer-experience/customer-rights/"
        titleTow="حقوق مشتریان"
      />

      <div className={cx(styles.mainPage)}>
        <div
          className={cx(
            styles.progressBarMain,
            scrollDir !== "down" ? styles.Stick : styles.notStick
          )}
        >
          <motion.div
            className={cx(styles.progressBarInner)}
            style={{ scaleX: scroll1 }}
            transition={spring}
          />
          <motion.div
            className={cx(styles.progressBarInner)}
            style={{ scaleX: scroll2 }}
            transition={spring}
          />

          {/* On Mobile  */}
          <motion.div
            className={cx(styles.progressBarInnerMobile)}
            style={{ scaleX: scrollAll }}
            transition={spring}
          />
        </div>
        <div
          className={cx(
            styles.progressBarMainTitles,
            scrollDir !== "down" ? styles.Stick : styles.notStick
          )}
        >
          <div
            className={cx(
              styles.progressBarInnerTitle,
              ref1inViewport
                ? ref2inViewport
                  ? styles.mobileShrinkable
                  : ""
                : styles.mobileShrinkable
            )}
            onClick={() =>
              ref1?.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              })
            }
          ></div>
          {/* <div className={cx(styles.progressBarInnerVline , "d-none d-md-block")}></div> */}

          {/* <div className={cx(styles.progressBarInnerVline ,  "d-none d-md-block")}></div> */}
          <div
            className={cx(
              styles.progressBarInnerTitle,
              ref2inViewport ? "" : styles.mobileShrinkable
            )}
            onClick={() =>
              ref2?.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              })
            }
          ></div>
        </div>

        <div className={cx(styles.pageContainer)}>
          <div ref={ref1} className={cx(styles.experience)}>
            <h1 className="py-2">
              مشتریان دیجی‌کالا از چه حقوقی برخوردار هستند؟
            </h1>
            <p>
              دیجی‌کالا دو نوع تعهد نسبت به مشتریان خود دارد؛ تعهداتی که در
              راستای مشتری‌مداری و ایجاد تجربه خوب توسط برند تعریف و به مشتری
              وعده داده شده، و تعهداتی که به موجب قانون تکلیف شده و دارای ضمانت
              اجرایی حقوقی است.
            </p>
            <p>قوانین متعددی در تجارت به حقوق مشتریان اشاره دارد:</p>
            <p>
              <a
                href="https://rc.majlis.ir/fa/law/show/93997"
                target="_blank"
                rel="noopener noreferrer"
              >
                قانون تجارت الکترونیک{" "}
              </a>
              مهم‌ترین قانون مرتبط با حقوق مشتریان در خرید آنلاین است که در سال
              ۱۳۸۲ در مجلس تصویب شده و به ساز و کارهای تجارت الکترونیک و حقوق
              مشتریان اشاره دارد.
            </p>
            <p>
              بر اساس قانون تجارت الکترونیک ارائه موارد زیر از سوی
              <span className={cx(styles.greenSpan)}> فروشنده </span>
              الزامی‌ست:
            </p>
            <div>
              <Image
                src={cxr1}
                alt="rights icon"
                className={cx(styles.inlineIcon, "me-3")}
              />{" "}
              مشخصات فنی کالا
            </div>
            <div>
              <Image
                src={cxr2}
                alt="rights icon"
                className={cx(styles.inlineIcon, "me-3")}
              />{" "}
              هویت تامین کننده
            </div>
            <div>
              <Image
                src={cxr3}
                alt="rights icon"
                className={cx(styles.inlineIcon, "me-3")}
              />{" "}
              آدرس محل تجاری برای شکایت احتمالی
            </div>
            <div>
              <Image
                src={cxr4}
                alt="rights icon"
                className={cx(styles.inlineIcon, "me-3")}
              />{" "}
              اطلاعات مربوط به ضمانت
            </div>
            <div>
              <Image
                src={cxr5}
                alt="rights icon"
                className={cx(styles.inlineIcon, "me-3")}
              />{" "}
              پشتیبانی پس از فروش
            </div>
            <div>
              <Image
                src={cxr6}
                alt="rights icon"
                className={cx(styles.inlineIcon, "me-3")}
              />{" "}
              امکان انصراف از خرید در حداقل 7 روز کاری بدون تحمیل هزینه به مشتری
              و همراه با باز پرداخت کامل قیمت کالا
            </div>

            <div className={cx(styles.purpleContainer)}>
              <div className="d-flex text-center py-3">
                <h6>
                  حق انصراف از خرید بی‌قید و شرط نیست و تنها در شرایطی قابل اجرا
                  است که کالا در شرایط اولیه بازگشت داده شود. هزینه بازگشت کالا
                  ناشی از انصراف نیز برعهده خریدار است.
                </h6>
              </div>
            </div>

            {/* <p>
                به‌عنوان مثال 
                    <span className={cx(styles.greenSpan )}>
                    {" "}
                    برای کالاهایی که قیمت آنها تحت تاثیر نوسانات بازار هستند امکان بازگشت سلیقه‌ای وجود ندارد. 
                    {" "}
                    </span>
                    کالای بازگشتی حتماً باید در شرایط اولیه قرار داشته باشد و برای کالایی از بسته خود خارج شود و به‌اصطلاح دست دوم محسوب شود امکان انصراف از خرید برای مشتری فراهم نیست.
                </p> */}
            <p>
              بر اساس قانون تجارت الکترونیک در صورتی‌که انصراف از خرید به‌دلیل
              معیوب بودن کالا باشد هزینه ارسال بر عهده فروشنده است.
            </p>

            <div className={cx(styles.purpleContainer)}>
              <div className="d-flex text-center py-3">
                <h6>
                  در صورت تأمین نشدن کالا توسط فروشنده، تعهد بازپرداخت وجه
                  دریافتی از سوی مشتری با فروشنده است. اگر مشخص شود فروشنده از
                  ابتدا امکان تامین کالا را نداشته طبق قانون مجازات خواهد شد.
                </h6>
              </div>
            </div>

            <p>همچنین بر اساس قانون تجارت الکترونیک:</p>

            <div className={cx(styles.purpleContainer)}>
              <div className="d-flex text-center py-3">
                <h6>
                  تمامی هزینه‌های خرید علاوه بر قیمت کالا شامل هزینه ارسال، تماس
                  و مالیات برعهده خریدار است.
                </h6>
              </div>
            </div>

            <p>
              علاوه بر قانون تجارت الکترونیک، می‌توان از
              <span className={cx(styles.greenSpan)}>
                {" "}
                قانون حمایت از حقوق مصرف‌کنندگان، قانون حمایت از حقوق کاربران در
                فضای مجازی، قانون جرایم رایانه‌ای{" "}
              </span>
              و آیین‌نامه‌های مرتبط صنفی نیز به‌عنوان قوانینی که در آنها به حقوق
              مشتریان اشاره شده نام برد.
            </p>
            <p>
              دیجی‌کالا ضمن تعهد کامل در اجرای این قوانین در تلاش است با ایجاد
              ساز و کارهای سخت‌گیرانه و پذیرش خسارت، تجربه خوشایندی برای مشتریان
              رقم بزند.
            </p>

            <div className={cx(styles.purpleContainer)}>
              <div className="d-flex text-center py-3">
                <h6>
                  دیجی‌کالا به‌عنوان یک پلتفرم دو سویه بین مشتری و فروشنده،
                  نیازمند ساز و کارهایی‌ست که بتواند قضاوت منصفانه‌ای در راستای
                  رعایت حقوق طرفین داشته باشد. موضوعی که قوانین موجود نسبت به آن
                  موضعی نداشته‌اند.
                </h6>
              </div>
            </div>
          </div>

          <div ref={ref2} className={cx(styles.experienceShare)}>
            <div className={cx(styles.share)}>
              <div className="d-block">
                <h6 className={cx(styles.shareTitle)}>به اشتراک بگذارید</h6>
              </div>
              <div className="d-block">
                <span
                  onClick={onShareHandler}
                  className={cx(styles.copyLink, "me-3")}
                >
                  <Image src={linkShare} alt="Link Share" />
                </span>
                <a
                  className="me-3"
                  target="_blank"
                  rel="noreferrer"
                  href={`mailto:?subject=${pageDetails.pageTitle}
                                &${pageDetails.pagePath}
                                &body=سلام %0A این صفحه از سایت درباره دیجی‌کالا رو ببین.%0A سپاس
                                `}
                >
                  <Image src={emailShare} alt="Email Share" />
                </a>
                <a
                  className="me-3"
                  rel="noreferrer"
                  target="_blank"
                  href={`https://t.me/share/url?url=${pageDetails.pagePath}} 
                    &text=${encodeURIComponent(pageDetails.pageTitle)}`}
                >
                  <Image src={telegramShare} alt="Telegram Share" />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={`whatsapp://send?text=${encodeURIComponent(
                    pageDetails.pagePath
                  )}`}
                  data-action="share/whatsapp/share"
                >
                  <Image src={whatsappShare} alt="Whatsapp Share" />
                </a>
              </div>
            </div>

            <div className={cx(styles.comment)}>
              <div className="d-block">
                <h6 className={cx(styles.shareTitle)}>
                  آیا این مطلب برایتان مفید بود؟
                </h6>
              </div>
              <div className="d-block">
                <span className="me-3">
                  <Image
                    src={dislike}
                    alt="Dislike"
                    style={{ cursor: "pointer" }}
                  />
                </span>
                <span>
                  <Image src={like} alt="Like" style={{ cursor: "pointer" }} />
                </span>
              </div>
            </div>
          </div>
          {/* </div> */}
        </div>
      </div>
    </>
  );
};

export default Index;
